import { FC, useEffect, useState } from 'react'
import { ArrowRightIcon } from 'lucide-react'
import { setShowLessonSidebar, useAppDispatch, useAppSelector } from '../../../redux'
import { getCourseCompletedPercentage, theme, useIsMobile } from '../../../utils'
import { LessonSidebarModule } from '..'
import { StyledLessonSidebar } from '.'

const LessonSidebar: FC = () => {
  const dispatch = useAppDispatch()
  const [completed, setCompleted] = useState(0)
  const { isMobile } = useIsMobile()
  const { course, loading, showSidebar } = useAppSelector((state) => state.course)

  useEffect(() => {
    setCompleted(Math.floor(getCourseCompletedPercentage(course)))
  }, [course?.modules])

  if (showSidebar === false) {
    return null
  }

  if (showSidebar === undefined && isMobile) {
    return null
  }

  return (
    <StyledLessonSidebar $loading={loading} $show={showSidebar}>
      <div className="header">
        <div className="header-group">
          <div className="course-details">
            <span className="course-title">{!loading && course?.title}</span>
            <span className="course-progress">{!loading && `${completed}% completed`}</span>
          </div>
          <button className="expand-btn" onClick={() => dispatch(setShowLessonSidebar(false))}>
            <ArrowRightIcon />
          </button>
        </div>
        <div className="progress">
          <div className="progress-value" style={{ width: `${loading ? 0 : completed}%` }}></div>
        </div>
      </div>
      <div className="module-list">
        {!loading &&
          course?.modules?.map((module, index) => {
            return <LessonSidebarModule module={module} index={index} key={module._id} />
          })}
      </div>
    </StyledLessonSidebar>
  )
}

export default LessonSidebar
